export default __webpack_public_path__ + "static/media/call_foley.99e2b70a.mp3";